import { Filter } from 'src/utils/composeFilter.ts';
import { SetURLSearchParams } from 'react-router-dom';
import { CheckboxHandler } from 'src/modules/common/types/CheckboxHandler.ts';

export const createCheckboxHandler = (
    filter: Filter,
    searchParams: URLSearchParams,
    setSearchParams: SetURLSearchParams,
    state: unknown,
): CheckboxHandler => (detail: { name: string; value: string | string[] }): Filter => {
    const value = filter ? (filter[detail.name] || []) : [];
    const newValue = (Array.isArray(detail.value) ? detail.value : [detail.value])
        .reduce((acc, curr) => {
            if (value.includes(curr)) {
                return acc.filter((item) => item !== curr);
            }
            acc.push(curr);
            return acc;
        }, value);
    const newFilter = {
        ...filter,
        [detail.name]: newValue,
    };
    Object
        .entries(newFilter)
        .forEach(([name, v]) => {
            if (v.length === 0) {
                searchParams.delete(name);
            } else {
                searchParams.set(name, JSON.stringify(v));
            }
        });

    setSearchParams(searchParams, { replace: true, state });
    return newFilter;
};
